<template>
  <div class="main">
    <report-top v-if="!scan">
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)" @on-row-click="$emit('obj', $event)">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增客户' : '编辑客户'" ref="formModel" :labelWidth="100" width="1200">
      <tableForm slot="shippingAddressList" ref="shippingAddressList" :forms="shippingAddressListForms"
        :item1="shippingAddressListItem" v-model="item.shippingAddressList" @addItem="addItem($event, 'xiehuo')">
      </tableForm>
      <tableForm slot="pickupAddressList" ref="pickupAddressList" :forms="pickupAddressListForms"
        :item1="pickupAddressListItem" v-model="item.pickupAddressList" @addItem="addItem($event, 'tihuo')">
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
import tableWrap from "../common/tableWrap.vue";
var dzDate = [];
var taizhang = [];
export default {
  props: ["scan", "checkMore"],
  components: { tableWrap },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "expand",
          width: 70,
          align: "center",
          render: (h, data) => {
            return h(tableWrap, {
              //局部注册组件不需要加引号
              props: {
                //tableList: data.row.pickupAddressList,
                tableList: [
                  {
                    columns: this.pickupAddressListForms,
                    tableData: data.row.pickupAddressList,
                  },
                  {
                    columns: this.shippingAddressListForms,
                    tableData: data.row.shippingAddressList,
                  },
                ],
              },
            });
          },
        },
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        types: "中港",
        code: "",
        name: "", //客户名称
        contact: "",
        manager: "",
        tel: "",
        fax: "",
        mobile: "",
        address: "",
        shippingAddressList: [], //送货地址
        pickupAddressList: [], //提货地址
        creditCode: "",
        saleman: "",
        salemanId: "",
        ticket: "",
        remark: "",
        settleType: "现结",
        signCompany: "",
        dzDay: 10,
        tallyAccountId: "",
        id: "",
      },
      forms: [
        {
          title: "客户名称",
          key: "name",
          type: "Input",
          required: true,
          span: 6,
        },
        {
          title: "客户编号（字母缩写）",
          key: "code",
          placeholder: "填写简称，字母+数字",
          type: "Input",
          required: true,
          span: 6,
        },
        {
          title: "签约公司",
          key: "signCompany",
          type: "Input",
          span: 6,
        },
        {
          title: "对账日期",
          key: "dzDay",
          key2: "dzDay2",
          type: "Select",
          selectType: "obj",
          selectItems: dzDate,
          span: 6,
        },
        {
          title: "台账选择",
          key: "tallyAccountId",
          key2: "tallyAccountName",
          type: "Select",
          selectType: "obj",
          selectItems: taizhang,
          span: 6,
        },
        {
          title: "联系人",
          key: "contact",
          type: "Input",
          span: 6,
        },
        {
          title: "联系方式",
          key: "tel",
          type: "Input",
          span: 6,
        },
        {
          title: "分类",
          key: "types",
          type: "Select",
          selectItems: ["中港", "非中港"],
          required: true,
          span: 6,
        },

        {
          title: "合同编号",
          key: "contractNo",
          type: "Input",
          span: 6,
        },
        {
          title: "结算方式",
          key: "settleType",
          type: "Select",
          //selectItems: ["月结", "现结", "单结", "其他"],
          selectItems: this.lydic.getA("settleType"),
          required: true,
          span: 6,
        },
        /* {
          title: "地址",
          key: "address",
          type: "selectAddMap",
        }, */
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
          span: 6,
        },
        {
          title: "提货地址",
          key: "pickupAddressList",
          noTable: true,
          slotForm: "pickupAddressList",
          span: 24,
        },
        {
          title: "卸货地址",
          key: "shippingAddressList",
          noTable: true,
          slotForm: "shippingAddressList",
          span: 24,
        },
      ],
      shippingAddressListForms: [
        {
          title: "卸货地址",
          key: "address",
          slot: "address",
          keyX: "x",
          keyY: "y",
          type: "selectAddMap",
          required: true,
          width: 400,
        },
        {
          title: "联系人",
          key: "contact",
          type: "Input",
        },
        {
          title: "联系方式",
          key: "tel",
          type: "Input",
        },
      ],
      shippingAddressListItem: {
        address: "",
        x: 0,
        y: 0,
        isUse: 1,
        name: "",
        contact: "",
        tel: "",
      },

      pickupAddressListForms: [
        {
          title: "提货地址",
          key: "address",
          slot: "address",
          keyX: "x",
          keyY: "y",
          type: "selectAddMap",
          required: true,
          width: 400,
        },
        {
          title: "联系人",
          key: "contact",
          type: "Input",
        },
        {
          title: "联系方式",
          key: "tel",
          type: "Input",
        },
      ],
      pickupAddressListItem: {
        address: "",
        x: 0,
        y: 0,
        isUse: 1,
        name: "",
        contact: "",
        tel: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "2,4,0",
        },
      ],
      total: 0,
    };
  },
  methods: {
    addItem(index, m) {
      if (m == "tihuo") {
        //pickupAddressList
        var tt = this.item.pickupAddressList;
        tt[index].tel = this.item.tel;
        tt[index].contact = this.item.contact;
      }
      if (m == "xiehuo") {
        //shippingAddressList
        var tt = this.item.shippingAddressList;
        tt[index].tel = this.item.tel;
        tt[index].contact = this.item.contact;
      }
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].dzDay2 =
            data[i].dzDay == null ? "" : "每月" + data[i].dzDay + "日";
          if (data[i].pickupAddressList == null) {
            data[i].pickupAddressList = [];
          }
          if (data[i].shippingAddressList == null) {
            data[i].shippingAddressList = [];
          }
          for (let j = 0; j < data[i].pickupAddressList.length; j++) {
            data[i].pickupAddressList[j].isUse2 = this.$t(
              "bool." + data[i].pickupAddressList[j].isUse
            );
          }
          for (let j = 0; j < data[i].shippingAddressList.length; j++) {
            data[i].shippingAddressList[j].isUse2 = this.$t(
              "bool." + data[i].shippingAddressList[j].isUse
            );
            
          }
        }
        this.tableData = data;
        
      });
    },
    addUpdate(name) {

      var pwdRegex = new RegExp("^[A-Za-z1-9]+$");

      if (!pwdRegex.test(this.item.code)) {
        alert("客户编号只能填写英文字母/数字");
        return false;
      }
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.utils.loading(this, "提交中");
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/customer/add",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/customer/update",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-base/customer/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory

    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    getTaizhang() {
      taizhang.length = 0;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/tallyAccount/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          taizhang.push(obj);
        }
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    dzDate.length = 0;
    for (let i = 1; i <= 28; i++) {
      var obj = {
        id: i,
        name: "每月" + i + "日",
      };
      dzDate.push(obj);
    }
    this.getTaizhang();
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/wuliukehuguanli.vue